import type { StateCreator } from "zustand";

export interface DebugForceRawSlice {
    debugForceRawStreams: boolean;
    toggleDebugForceRawStreams: () => void;
}

export const createDebugForceRawSlice: StateCreator<DebugForceRawSlice, [], [], DebugForceRawSlice> = (set) => ({
    debugForceRawStreams: false,
    toggleDebugForceRawStreams: () => set((state) => ({ debugForceRawStreams: !state.debugForceRawStreams })),
});
